import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { AppointmentInput } from 'src/app/core/models/calendar/appointment-input';
import { CalendarFacadeService } from 'src/app/facades/calendar/calendar-facade.service';

@Component({
  selector: 'app-cancel',
  templateUrl: './cancel.component.html',
  styleUrls: ['./cancel.component.scss']
})
export class CancelComponent implements OnInit {
  appointmentDetails: any;

  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheet: MatBottomSheetRef<CancelComponent>,
    private calendarFacadeService: CalendarFacadeService) {
    this.appointmentDetails = data;
  }

  ngOnInit(): void {
  }
  close() {
    this.bottomSheet.dismiss();
  }
  cancelAppointment() {
    try {
      let data: AppointmentInput = {
        appointmentId: this.appointmentDetails.appointmentId,
        groupId: 0,
        recordStatus: false,
        updatedBy: this.appointmentDetails.stylistId,
      };
      this.calendarFacadeService.cancelAppointment(data).subscribe({
        next: (res) => {
          this.bottomSheet.dismiss('success');
        }, error(err) {
          this.bottomSheet.dismiss('False');
        }
      })
    } catch (err) {
      this.bottomSheet.dismiss('False');
    }
  }

}
